import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" * 部分地區不提供 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 場地 ")
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.options)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.city),
        style: _normalizeStyle({ background: _ctx.type === 'modal' && 'white' })
      }, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distsList, (dist) => {
            return (_openBlock(), _createElementBlock("li", {
              key: dist.cityId,
              class: _normalizeClass(_ctx.cntCity === dist.cityId && _ctx.$style.selected),
              onClick: () => (_ctx.cntCity = dist.cityId)
            }, [
              _createTextVNode(_toDisplayString(dist.cityName) + " ", 1),
              _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.distCount[dist.cityId]), 513), [
                [_vShow, _ctx.distCount[dist.cityId]]
              ])
            ], 10, _hoisted_1))
          }), 128))
        ]),
        _hoisted_2
      ], 6),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distsList[_ctx.cntCity].dists, (dist) => {
          return (_openBlock(), _createElementBlock("li", {
            key: dist,
            onClick: ($event: any) => (_ctx.changeTempDists(dist)),
            class: _normalizeClass([
          _ctx.tempDists.includes(dist) && _ctx.$style.selected,
          _ctx.isDisable(dist) && 'disable',
        ])
          }, _toDisplayString(_ctx.isDisable(dist) ? '*' : '') + _toDisplayString(_ctx.districtName(dist, true)), 11, _hoisted_3))
        }), 128))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.submit)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.text)
      }, [
        (_ctx.sportName)
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.sportName), 1),
              _hoisted_6
            ]))
          : (_openBlock(), _createElementBlock("small", _hoisted_7, "請選擇運動類型")),
        _createElementVNode("small", {
          class: _normalizeClass([
          _ctx.isShake && 'shakeText',
          _ctx.tempDists.length === 3 && _ctx.$style.warning,
        ])
        }, _toDisplayString(_ctx.tempDists.length) + " / 3 ", 3)
      ], 2),
      _createVNode(_component_Button, {
        btnName: "Search",
        btyType: "fillBtn",
        title: "搜尋",
        class: _normalizeClass(_ctx.tempDists.length === 0 && 'disable'),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.tempDists.length > 0 && (_ctx.submit(), _ctx.closeFunc && _ctx.closeFunc())), ["stop"]))
      }, null, 8, ["class"])
    ], 2)
  ], 64))
}